export const prodPathnamesDict = {
  en: {
    aboutUs: '/about-us-en/',
    citizenship: '/citizenship-and-residence-en/',
  },
  de: {
    aboutUs: '/de/about-us/',
    citizenship: '/de/citizenship/',
  },
  ru: {
    aboutUs: '/ru/about-us/',
    citizenship: '/ru/citizenship-and-residence/',
  },
  tr: {
    aboutUs: '/about-us-en/',
    citizenship: '/citizenship-and-residence-en/',
  },
  es: {
    aboutUs: '/es/about-us/',
    citizenship: '/citizenship-and-residence-en/',
  },
};

export const homePageDict = {
  en: {
    aboutCompany: 'About the company',
  },
  de: {
    aboutCompany: 'Über das Unternehmen',
  },
  ru: {
    aboutCompany: 'О компании',
  },
  tr: {
    aboutCompany: 'Hakkında',
  },
  es: {
    aboutCompany: 'Sobre la empresa',
  },
};

export const blogMetaTitlesDict = {
  en: {
    title: `Articles: {countryName} - Immigrant Invest`,
    description: `Category of blog - {countryName}`,
  },
  de: {
    title: `Artikel: {countryName} - Immigrant Invest`,
    description: `Kategorie des Blogs - {countryName}`,
  },
  ru: {
    title: `Статьи: {countryName} - Immigrant Invest`,
    description: `Категория статей: {countryName}`,
  },
  tr: {
    title: `Makaleler: {countryName} - Immigrant Invest`,
    description: `Blog kategorisi - {countryName}`,
  },
  es: {
    title: `Artículos: {countryName} - Immigrant Invest`,
    description: `Categoría del blog - {countryName}`,
  },
};

export const insiderMetaTitlesDict = {
  en: {
    title: `News: {countryName} - Immigrant Invest`,
    description: `Category of news - {countryName}`,
  },
  ru: {
    title: `Новости: {countryName} - Immigrant Invest`,
    description: `Категория новостей: {countryName}`,
  },
};
